import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.sass']
})
export class AboutComponent implements OnInit {
  @ViewChild('about', {read: ElementRef}) about;

  constructor() { }

  ngOnInit(): void {
  }

  aboutHandler = () => {
      this.about.nativeElement.style.display = 'none'
    }
  
}
